import styled from "styled-components";
import bloodCountImage from "./img/iconBloodCount.PNG";

function Head() {
    return(
        <MasterContainer>
            <Logo></Logo>
            <Title>
                Análise de Infecções em hemogramas<br/>
                <SubTitle>Modelagem Computacional em Ciência e Tecnologia - MCCT</SubTitle>
                <SubTitle>UFF - Universidade Federal Fluminense</SubTitle>
                <SubTitle>Cleber Viana - cleberviana@id.uff.br</SubTitle>
            </Title>
        </MasterContainer>
    )
}

export default Head;

const MasterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    margin-top: 20px;
    //border: solid 1px;
    width: 800px;
    border-radius: 5px;

`
const Logo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid;
    width: 60px;
    height: 86px;
    transform: rotate(-15deg);
    margin-right: 20px;
    background-image: url(${bloodCountImage});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;

`
const Title = styled.div`
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    font-size: 24pt;
    font-weight: bold;
    //background-color: rgba(0,0,0,.6);
    //color: white;
    border-radius: 5px;
    padding: 10px 20px;

`

const SubTitle = styled.span`
    font-size: 12pt;
    font-style: italic;
    font-weight: normal;
    //background-color: rgba(0,0,0,.6);
    //color: white;
    border-radius: 5px;
    margin-top: 5px;

`